import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';

/*

Props:

*/

const StyledLink = styled.a`
    
    font-size: 16px;
    font-family: ${constants.text.baseFontStyles.fontFamily};
    color: ${constants.color.primary};
    :hover { 
        text-decoration: underline;
    }

    @media (max-width: ${props => (props.breakPoint1) ? props.breakPoint1 : '0'}px){

    }
`;


const Link = ({ style, onClick, children, ...rest }) => (
    <StyledLink style = {style}  onClick = {onClick} {...rest} >
        { children }
    </StyledLink>
) 

export default Link;

// color: ${props => (props.color) ? props.color : 'red'};
//   box-shadow: -7px 11px 78px -24px rgba(0,0,0,0.16);


// WEBPACK FOOTER //
// ./src/js/components/Primatives/Link.jsx